<!--
 * @Description: 
 * @Author: Lidya
 * @Date: 2022-12-08 12:26:11
 * @LastEditors: Lidya
 * @LastEditTime: 2022-12-15 18:31:49
-->
<template>
  <div :id="galleryID">
    <a
      v-for="(image, key) in images"
      :key="key"
      :href="image.largeURL"
      :data-pswp-width="image.width"
      :data-pswp-height="image.height"
      target="_blank"
      rel="noreferrer"
    >
      <img :src="image.thumbnailURL" alt="" />
    </a>
  </div>
</template>

<script>
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js'
// import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/dist/photoswipe.css';

export default {
  name: 'SimpleGallery',
  props: {
    galleryID: String,
    images: Array,
  },
  setup(props) {
    // console.log('galleryIDprops.images--', props.images)
    return {
      imagesData: props.images,
    };
  },
  mounted() {
    this.imagesData = this.$props.images;
    console.log('galleryIDprops---', this.imagesData)
    if (!this.lightbox) {
      this.lightbox = new PhotoSwipeLightbox({
        gallery: '#' + this.$props.galleryID,
        children: 'a',
        pswpModule: () => import('photoswipe'),
      });
      this.lightbox.init();
    }
  },
  unmounted() {
    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }
  },
  methods: {},
};
</script>
